import _classCallCheck from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _defineProperty2 from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../defaultTheme";
var FORMATS = {
  WEBP: "webp",
  JPEG: "jpg"
};
export var StyledLazyImage = styled.div.withConfig({
  displayName: "LazyImage__StyledLazyImage",
  componentId: "sc-1c5fd3o-0"
})(["width:100%;height:100%;position:absolute;"]);
var Image = styled.img.withConfig({
  displayName: "LazyImage__Image",
  componentId: "sc-1c5fd3o-1"
})(["z-index:", ";position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);min-width:100%;min-height:100%;opacity:", ";transition:opacity ", " ease-in-out;", ";"], function (_ref) {
  var visible = _ref.visible;
  return visible ? "1" : "0";
}, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? "1" : "0";
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.durationFast;
}, function (_ref4) {
  var lowRes = _ref4.lowRes;
  return lowRes && css(["filter:blur(3px);"]);
});
Image.defaultProps = {
  theme: defaultTheme
};

var getPictureType = function getPictureType(picture) {
  var _TYPES;

  var TYPES = (_TYPES = {}, _defineProperty2(_TYPES, FORMATS.WEBP, "image/webp"), _defineProperty2(_TYPES, FORMATS.JPEG, "image/jpg"), _TYPES);
  return TYPES[picture];
};

var Picture = function Picture(_ref5) {
  var pictures = _ref5.pictures,
      name = _ref5.name,
      loaded = _ref5.loaded,
      onLoad = _ref5.onLoad,
      lowRes = _ref5.lowRes;
  return React.createElement("picture", null, Object.keys(pictures).map(function (picture) {
    return React.createElement(React.Fragment, {
      key: picture
    }, React.createElement("source", {
      srcSet: pictures[picture],
      type: getPictureType(picture)
    }), picture === "jpg" && React.createElement(Image, {
      onLoad: onLoad,
      src: pictures[picture],
      alt: name,
      visible: loaded,
      lowRes: lowRes
    }));
  }));
};

var LazyImage =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(LazyImage, _React$PureComponent);

  function LazyImage() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, LazyImage);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LazyImage)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loaded: false
    });

    _defineProperty(_assertThisInitialized(_this), "fullResLoaded", function () {
      _this.setState({
        loaded: true
      });
    });

    return _this;
  }

  _createClass(LazyImage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          placeholder = _this$props.placeholder,
          original = _this$props.original,
          name = _this$props.name;
      var loaded = this.state.loaded;
      return React.createElement(StyledLazyImage, null, React.createElement(Picture, {
        pictures: original,
        name: name,
        loaded: loaded,
        onLoad: this.fullResLoaded
      }), placeholder && React.createElement(Picture, {
        pictures: placeholder,
        lowRes: true,
        name: name,
        loaded: !loaded
      }));
    }
  }]);

  return LazyImage;
}(React.PureComponent);

export default LazyImage;